import dayjs from "dayjs"

const OPTIONS: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
}

const OPTIONS_WITH_TIME: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
}

export const dateToString = (date: Date) => {
    return new Date(date).toLocaleDateString(undefined, OPTIONS)
}
export const dateToStringWithTime = (date: Date) => {
    return new Date(date).toLocaleDateString(undefined, OPTIONS_WITH_TIME)
}
export const getDateFromId = (id: string) => {
    return new Date(parseInt(id.substring(0, 8), 16) * 1000)
}

export const getNextBillingDate = (startDate: Date, period = 1): Date => {
    const start = dayjs(startDate)
    const current = dayjs()

    const monthsDiff = current.diff(start, "month")
    const cyclesPassed = Math.floor(monthsDiff / period)

    let nextBilling = start.add((cyclesPassed + 1) * period, "month")

    if (nextBilling.isBefore(current) || nextBilling.isSame(current, "day")) {
        nextBilling = nextBilling.add(period, "month")
    }

    const billingDay = start.date()
    const lastDayOfMonth = nextBilling.endOf("month").date()
    if (billingDay > lastDayOfMonth) {
        nextBilling = nextBilling.endOf("month")
    }

    return nextBilling.toDate()
}
